import { Component } from '@angular/core';
import { FileFormField } from '../../../form/auto-form.type';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileUploader } from '../../../file-uploader/file-uploader.component';
import { FormFieldAdapter } from '../../adapters/form-field.adapter';
import { ArrayValidator } from '../../validators/array.validator';

@Component({
  selector: 'app-file-form-field',
  standalone: true,
  imports: [FileUploader],
  templateUrl: './file-form-field.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FileFormFieldComponent,
      multi: true,
    },
  ],
})
export class FileFormFieldComponent extends FormFieldAdapter<
  FileFormField<any>
> {
  override ngOnInit(): void {
    super.ngOnInit();

    if (this.formControl && this.formField()?.required) {
      this.formControl.addValidators([ArrayValidator()]);
    }

    this.defaultValues$.subscribe((defaultValues) => {
      if (defaultValues[this.formField()?.field]) {
        this.writeValue(defaultValues[this.formField()?.field]);
      }
    });
  }
}
